define('app/sds/menu/demo/helper/sds-menu-demo-helper-service',[], function () {
	var _id = 0, demoGlyphicons = ["envelope", "search", "cog", "file", "time", "signal", "inbox", "list-alt", "lock", "flag", "tags", "book", "facetime-video", "picture", "map-marker", "adjust", "check", "leaf", "fire", "plane", "gift", "calendar", "shopping-cart", "folder-close", "comment", "hdd", "bullhorn", "briefcase"];
	var h = {
		hashString: function hashString(str) {
			var hash = 0, i, chr, len;
			if (str.length == 0) return hash;
			for (i = 0, len = str.length; i < len; i++) {
				chr = str.charCodeAt(i);
				hash = ((hash << 5) - hash) + chr;
				hash |= 0; // Convert to 32bit integer
			}
			return hash;
		}
	, numberForString: function numberForString(str, max) {
		var num = this.hashString("" + str);
		if (num < 0) {
			num = -num;
		}
		return num % max;
	}
	, glypiconClass: function glypiconClass(glyphicon, displayName, id) {
		if (!glyphicon) {
			return "glyphicon glyphicon-" + demoGlyphicons[this.numberForString(displayName || id, demoGlyphicons.length)];
		}
		else if (!/\s/.test(glyphicon)) {
			if (/^glyphicon-/.test(glyphicon)) {
				return "glyphicon " + glyphicon;
			}
			else if (/^fa-/.test(glyphicon)) {
				return "fa " + glyphicon;
			}
		}
		return glyphicon;
	}
	, componentObject: function componentObject(component, displayName) {
		return angular.isObject(component) ? component : {
			tag: component || "ap-demo-underconstruction",
			attrs: {
				"{[displayName]}": displayName
			}
		};
	}
	, componentMenuItem: function componentMenuItem(displayName, component, glyphicon, hidden) {
		if (angular.isString(component) && angular.isObject(glyphicon)) {
			var temp = component;
			component = glyphicon;
			glyphicon = temp;
		}
		return {
			Id: ++_id,
			Caption: displayName,
			ItemMode: "Directive",
			Component: this.componentObject(component, displayName),
			glyphiconClass: this.glypiconClass(glyphicon, displayName, _id),
			Hidden: hidden
		};
	}
	, crudMenuItem: function crudMenuItem(displayName, component, glyphicon, menuItems) {
		if (angular.isObject(glyphicon)) {
			menuItems = glyphicon;
			glyphicon = undefined;
		}
		if (menuItems) {
			if (!angular.isArray(menuItems)) {
				menuItems = [
					h.componentMenuItem("New", this.componentObject(menuItems.new), "glyphicon-certificate", true),
					h.componentMenuItem("Edit", this.componentObject(menuItems.edit), "glyphicon-edit", true)
				];
			}
		}
		else {
			menuItems = [
				h.componentMenuItem("New", this.componentObject(), "glyphicon-certificate", true),
				h.componentMenuItem("Edit", this.componentObject(), "glyphicon-edit", true)
			];
		}
		return this.mixedMenuItem(displayName, component, glyphicon, menuItems);
	}
	, mixedMenuItem: function mixedMenuItem(displayName, component, glyphicon, menuItems) {
		if (angular.isArray(glyphicon)) {
			menuItems = glyphicon;
			glyphicon = undefined;
		}
		glyphicon = this.glypiconClass(glyphicon, displayName, _id);
		return {
			Id: ++_id,
			Caption: displayName,
			ItemMode: "Directive",
			Component: this.componentObject(component, displayName),
			ChildMenuItems: angular.isArray(menuItems) ? menuItems : (menuItems ? [menuItems] : []),
			glyphiconClass: glyphicon
		};
	}
	, menuMenuItem: function menuMenuItem(displayName, glyphicon, menuItems) {
		if (angular.isArray(glyphicon)) {
			menuItems = glyphicon;
			glyphicon = undefined;
		}
		glyphicon = this.glypiconClass(glyphicon, displayName, _id);
		return {
			Id: ++_id,
			Caption: displayName,
			ChildMenuItems: angular.isArray(menuItems) ? menuItems : (menuItems ? [menuItems] : []),
			glyphiconClass: glyphicon
		};
	}
	, menuFactory: function menuFactory(displayName, factory) {
		return {
			Id: ++_id,
			Caption: displayName,
			Command: "menu-factory=" + factory,
			CommandText: "menu-factory=" + factory
		};
	}
	};
	return h;
});
